import { render, staticRenderFns } from "./SalesDevelopmentBreakdown.vue?vue&type=template&id=3fb5d8b8&"
import script from "./SalesDevelopmentBreakdown.vue?vue&type=script&lang=js&"
export * from "./SalesDevelopmentBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports